import React from 'react';
import Chart from './Chart';
import { dashboardActions } from '../../../../../actions/dashboard.action';
import moment from 'moment';
import parser from '../../parser';

const dateFormat = 'MM/DD/yyyy HH:mm:ss';
function toUTC(dt) {
  return moment.utc(dt, dateFormat).format();
}

const LiveChartContainer = (props) => {
  const border = `${props.borderSize}px ${props.borderStyle} ${props.borderColor}`;
  let isVertical = true;
  const boxSize =
    props.tagLocation === 'None' ? '100%' : `calc(100% - ${props.tagBoxSize}%)`;
  // - ${props.borderSize * 2}px
  let container = '';
  if (props.tagLocation) {
    switch (props.tagLocation.toLocaleLowerCase()) {
      case 'top':
        container = 'flex-column';
        break;
      default:
        container = 'flex-column flex-column-reverse';
        break;
    }
  }
  const [data, updateData] = React.useState([]);
  const [units, updateUnits] = React.useState('');
  const [msg, setMsg] = React.useState('Data is fetching ...');
  React.useEffect(() => {
    const toDate = toUTC(moment().toDate());
    const fromDate = toUTC(
      moment().subtract(props.timeRange, 'minutes').toDate(),
    );
    dashboardActions
      .getTrendV2(props.sensorId, fromDate, toDate)
      .then((resp) => {
        const _data = parser(resp)[1];
        if (_data.length) {
          updateData(_data);
          updateUnits(resp[0].units);
        } else {
          setMsg('No data available for range selected');
        }
      })
      .catch((err) => console.log(err));

    const intervalId = setInterval(async () => {
      const toDate = toUTC(moment().toDate());
      const fromDate = toUTC(
        moment().subtract(props.timeRange, 'minutes').toDate(),
      );
      setMsg('Data is fetching ...');
      await dashboardActions
        .getTrendV2(props.sensorId, fromDate, toDate)
        .then((resp) => {
          const _data = parser(resp)[1];
          if (_data.length) {
            updateData(_data);
            updateUnits(resp[0].units);
            clearInterval(intervalId);
          } else {
            setMsg('No data available for range selected');
          }
        })
        .catch((err) => console.log(err));
    }, props.refreshRate);
    return function cleanUp() {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, []);
  console.log(props.tagLocation);
  return (
    <div
      id={props.id + '-chart'}
      className={`d-flex ${props.tagLocation === 'None' ? '' : container}`}
      style={{
        width: props.w,
        height: props.h,
        top: props.y,
        left: props.x,
        position: 'absolute',
        border: props.borderSize ? border : '1px solid black',
        zIndex: (props.index || 0) + 1,
      }}
    >
      {props.tagLocation && props.tagLocation !== 'None' ? (
        <div
          className="d-flex align-items-center justify-content-center --resize"
          style={{
            width: '100%',
            height: props.tagBoxSize + '%',
            color: props.tagTextColor && props.tagTextColor.toLocaleLowerCase(),
            fontSize: props.tagFontSize + 'px',
            fontFamily: props.tagFontName,
            backgroundColor:
              props.tagBackGroundColor &&
              props.tagBackGroundColor.toLocaleLowerCase(),
            overflowY: 'hidden',
            lineHeight: 1,
            wordBreak: 'break-all',
          }}
        >
          <div>{props.tagText}</div>
        </div>
      ) : null}
      <div
        className="d-flex justify-content-center align-items-center resize"
        style={{
          width: '100%',
          height: boxSize,
          backgroundColor: props.backgroundColor,
        }}
      >
        {data.length ? (
          <Chart {...props} baseData={data} units={units} />
        ) : (
          <span>{msg}</span>
        )}
      </div>
    </div>
  );
};

export default LiveChartContainer;
